import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { FormlyType } from '../ga-formly.service';
import { ExtraFieldType } from '../extra-field-type';
import { GaFormlyUtil } from '../ga-formly.util';

@Component({
  selector: 'formly-field-hidden',
  template: `
	  <input class="form-control" type="hidden" [ngClass]="classNames" [formControl]="formControl" [formlyAttributes]="field" />
	`
})
export class FormlyFieldHiddenComponent extends ExtraFieldType implements OnInit, AfterContentChecked {
  constructor(
    private formlyUtil: GaFormlyUtil
  ) {
    super();
  }

  public ngOnInit():void {
    this.classNames = this.formlyUtil.createClassNames(FormlyType.HIDDEN, <string>this.key, this.to.label);
  }

  public ngAfterContentChecked():void {
    // reset default value to undefined
    this.formlyUtil.defaultValueToUndefined(this.formControl, this.field);
  }
}